angular.module('app').filter('moeda', function () {
    return function (input) {
        return input;
    };
});

angular.module('app').filter('integer', function () {
    return function (input) {
        return input;
    };
});

angular.module('app').filter('percentual', function () {
    return function (input) {
        return input;
    };
});

angular.module('app').filter('decimal', function () {
    return function (input) {
        return input;
    };
});


angular.module('app').filter('trust', ['$sce', function ($sce) {
    return function (text) {
        return $sce.trustAsHtml(text);
    };
}]);

angular.module('app').filter('nl2br', function ($sce) {
    return function (input) {
        return $sce.trustAsHtml(input.replace(/\n/g, '<br>'));
    };
});

angular.module('app').filter('dataIsoBr', function () {
    return function (input) {
        return moment(input).format('DD/MM/YYYY HH:mm:ss')
    };
});